'use strict';

const overlayTokens = (theme) => ({
    overlayShadow: theme.shadows.default,
    overlayRadius: theme.radiuses.m,
    overlaySpaceToTarget: theme.space.component.y.xs,
    overlayBackgroundColor: theme.colors.body.background,
});

exports.overlayTokens = overlayTokens;
//# sourceMappingURL=overlay.js.map
